import { render, staticRenderFns } from "./PhoneActionForm.vue?vue&type=template&id=1675b47c&scoped=true"
import script from "./PhoneActionForm.vue?vue&type=script&lang=js"
export * from "./PhoneActionForm.vue?vue&type=script&lang=js"
import style0 from "./PhoneActionForm.vue?vue&type=style&index=0&id=1675b47c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1675b47c",
  null
  
)

export default component.exports